import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const slug = "sub-heading";

const SubHeadingServices = {
  // Define your API functions here

  get: async () => {
    const response = await apiService.get(`/${slug}`);
    return response.data;
  },
  getDisplayList: async () => {
    const response = await apiService.get(`/${slug}/getdisplaylist`);
    return response.data;
  },

  create: async (data) => {
    const response = await apiService.post(`/${slug}`, data);
    return response.data;
  },
  getById: async (id) => {
    const response = await apiService.get(`/${slug}/${id}`);
    return response.data;
  },
  update: async (id, data) => {
    const response = await apiService.put(`/${slug}/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/${id}`);
    return response.data;
  },
};

export default SubHeadingServices;
